import React from 'react'
import ErrorBoundary from './ErrorBoundary'
import Footer from './Footer'
import Header from './Header'
import PublicHeader from './PublicHeader'
import FooterPublic from './FooterPublic'

const PublicLayout = (props: any) => {
    return (
        <React.Fragment>
            <PublicHeader />
            <ErrorBoundary>
                {props.children}
            </ErrorBoundary>
            <FooterPublic />
        </React.Fragment>
    )
}

export default PublicLayout
